
export default {
  methods: {
    convertToHump(data) {
      if (typeof (data) === 'object') {
        if (Array.isArray(data)) {
          const arr = []
          for (let i = 0; i < data.length; i++) {
            arr[i] = this.convertToHump(data[i])
          }
          return arr
        } else {
          const obj = {}
          for (const key in data) {
            obj[this.convertToHump(key)] = typeof (data[key]) === 'object' ? this.convertToHump(data[key]) : data[key]
          }
          return obj
        }
      } else {
        return typeof data === 'string' ? data.includes('_') ? data.split('_').map((str, index) => { return index ? str[0].toUpperCase() + str.slice(1) : str }).join('') : data : data
      }
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
      return Y + M + D + h + m + s
    },
    getNowDate() {
      console.log('666', this.shuffle([this.getRandomNumberByRange(100, 999).toString().split('')])[0].join(''))
      console.log('6661', this.shuffle([this.getRandomNumberByRange(100, 999).toString().split('')])[0].join(''))
      console.log('suiji', this.getRandomNumberByRange(100, 999).toString().split(''))
      var date = new Date()
      // var sign2 = ':'
      var year = date.getFullYear() // 年
      var month = date.getMonth() + 1 // 月
      var day = date.getDate() // 日
      var hour = date.getHours() // 时
      var minutes = date.getMinutes() // 分
      var seconds = date.getSeconds() // 秒
      // var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天']
      // var week = weekArr[date.getDay()]
      // 给一位数的数据前面加 “0”
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds
      }
      return year.toString().substring(2) + month + day + hour + minutes + seconds + this.shuffle([this.getRandomNumberByRange(100, 999).toString().split('')])[0].join('') + this.shuffle([this.getRandomNumberByRange(100, 999).toString().split('')])[0].join('')
    },
    getRandomNumberByRange(start, end) {
      return Math.floor(Math.random() * (end - start) + start)
    },
    shuffle(arr) {
      let temp; let length = arr.length
      for (let i = 0; i < length - 1; i++) {
        const index = Math.floor(Math.random() * (length--))
        temp = arr[index]
        arr[index] = arr[length]
        arr[length] = temp
      }
      return arr
    },
    downloadFile(url, name) {
      window.fetch(url)
        .then(res => {
          if (res.status === 200) {
            return res.blob()
          }
          return false
        }, (error) => {
          console.log(error)
        })
        .then(
          blob => {
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style.display = 'none'
            // 使用获取到的blob对象创建的url
            const url = window.URL.createObjectURL(blob)
            a.href = url
            // 指定下载的文件名
            a.download = `${name}`
            a.click()
            document.body.removeChild(a)
            // 移除blob对象的url
            window.URL.revokeObjectURL(url)
          }
        )
    },
    timeFormate(timeStamp) {
      const y = new Date(timeStamp).getFullYear().toString()
      const M = (new Date(timeStamp).getMonth() + 1).toString().padStart(2, '0')
      const d = new Date(timeStamp).getDate().toString().padStart(2, '0')
      const h = new Date(timeStamp).getHours().toString().padStart(2, '0')
      const m = new Date(timeStamp).getMinutes().toString().padStart(2, '0')
      const s = new Date(timeStamp).getSeconds().toString().padStart(2, '0')
      return y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s
    }
  }
}
